export const hierarchyInitialState = [
  {
    id: "1",
    type: "President",
    status: 1,
    parent: null,
    child: 2,
  },
  { id: "2", type: "President", parent: 1, child: 2, status: 1 },
  { id: "3", type: "President", parent: 2, child: 3, status: 1 },
];
